import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["autofill", "children", "classes", "disabled", "focused", "invalid", "readOnly", "size", "subText", "success", "theme", "tooltip", "tooltipAbsolute", "tooltipProps", "subTextProps", "namespace"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { getMethodsForTestId } from "../../../utils/getMethodsForTestId";
import { FieldSubText } from '../FieldSubText';
import { FieldTooltip } from '../FieldTooltip';
import styles from './FieldRoot.css';
var cx = classNames.bind(styles);
export var FieldRoot = /*#__PURE__*/forwardRef(function FieldRoot(_ref, ref) {
  var autofill = _ref.autofill,
      children = _ref.children,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      disabled = _ref.disabled,
      focused = _ref.focused,
      invalid = _ref.invalid,
      readOnly = _ref.readOnly,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      subText = _ref.subText,
      success = _ref.success,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'b2c' : _ref$theme,
      tooltip = _ref.tooltip,
      tooltipAbsolute = _ref.tooltipAbsolute,
      tooltipProps = _ref.tooltipProps,
      subTextProps = _ref.subTextProps,
      namespace = _ref.namespace,
      props = _objectWithoutProperties(_ref, _excluded);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'fieldRoot'),
      getTestId = _getMethodsForTestId.getTestId,
      getNamespace = _getMethodsForTestId.getNamespace;

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: cx('root', classes.root)
  }, getTestId(), props), /*#__PURE__*/React.createElement("label", _extends({
    className: cx('container', "theme_".concat(theme), "size_".concat(size), {
      disabled: disabled,
      invalid: invalid,
      success: success,
      focused: focused,
      autofill: autofill,
      readonly: readOnly
    }, classes.container)
  }, getTestId('label')), children), tooltip && /*#__PURE__*/React.createElement(FieldTooltip, _extends({}, tooltipProps, {
    invalid: invalid,
    success: success,
    absolute: tooltipAbsolute,
    namespace: getNamespace()
  }), tooltip), subText && /*#__PURE__*/React.createElement(FieldSubText, _extends({}, subTextProps, {
    namespace: getNamespace(),
    invalid: invalid
  }), subText));
});